import routes from "../routes";

export const filteredRoutes = () => {
  const userRoutes = JSON.parse(localStorage.getItem("NsAppPages") || '{}');
  return routes.filter(route => {
    if (route.key === "index" || route.key === "about" || route.key === "contact") return true;
    return userRoutes[route.key];
  });
};